<template>
  <div class="smaller-container-wrapper full-height">
    <MobialisFormWithValidation
      @onValidate="submit"
      novalidate
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
    >
      <h2 class="mb-4">{{ $t('message.eCommerceV2.finance.incomeDetailsForm.heading') }}</h2>
      <div class="row form-row pb-2 pt-2">
        <div class="col-sm-6" v-for="(option, index) in incomeDetailsMethodOptions" :key="index">
          <MobialisFancyRadio
            rules="required"
            :textArray="[option]"
            name="tradeInOptions"
            v-model="incomeDetailsMethod"
            :data-cy="option.value"
          ></MobialisFancyRadio>
        </div>
      </div>
      <p class="text-danger small my-0" v-if="!isValid">{{ $t('message.eCommerceV2.pleaseSelect') }}</p>
      <div class="push-down-desktop">
        <mobialis-button type="submit" class="mt-5 mb-3" data-cy="continue">{{
          $t('message.common.continue')
        }}</mobialis-button>
      </div>
    </MobialisFormWithValidation>
  </div>
</template>

<script>
import cloneDeep from 'lodash/fp/cloneDeep';

export default {
  name: 'IncomeDetailsForm',
  data() {
    return {
      incomeDetailsMethod: cloneDeep(this.$store.state.user.financeDetails.incomeDetailsMethod),
      incomeDetailsMethodOptions: this.$t('message.eCommerceV2.finance.incomeDetailsForm.options'),
      isValid: true,
    };
  },
  methods: {
    submit(isValid) {
      if (!isValid) {
        this.isValid = false;
        return;
      }
      this.isValid = true;
      this.$store.commit('user/SET_INCOME_DETAILS_METHOD', this.incomeDetailsMethod);
      this.$router.push({ path: this.getNextRoutePath() });
    },
  },
};
</script>

<style lang="scss" scoped></style>
